import { QuestionnaireQuestions } from '@getpopsure/qnr-framework';
import { useQuery } from '@tanstack/react-query';
import { getQuotes } from 'features/generalQuestionnaire/generalPolicy/api';

const STALE_TIME = 1000 * 60 * 30;

export const useGetQuotes = <Questionnaire extends QuestionnaireQuestions>({
  featureName,
  answers,
}: {
  featureName: string;
  answers: Partial<Questionnaire>;
}) => {
  const {
    data: quotes,
    isError,
    error,
    isInitialLoading,
  } = useQuery(
    ['quotes', featureName, answers],
    () =>
      getQuotes({
        insuranceType: featureName.toUpperCase(),
        answers,
      }),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      enabled: Object.entries(answers).length > 0,
      staleTime: STALE_TIME,
    }
  );

  return {
    quotes,
    isError,
    error,
    isInitialLoading,
  };
};
